import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { BundleShowcase } from './components/BundleShowcase';
import { EmpathySection } from './components/EmpathySection';
import { AntiagingTruth } from './components/AntiagingTruth';
import { MethodPillars } from './components/MethodPillars';
import { BeforeAfter } from './components/BeforeAfter';
import { ExpertSection } from './components/ExpertSection';
import { EbookContents } from './components/EbookContents';
import { BonusStack } from './components/BonusStack';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Urgency } from './components/Urgency';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecentPurchasePopup } from './components/RecentPurchasePopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-cream-light font-sans selection:bg-gold/30" data-id="element-0">
      <AnnouncementBar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <BundleShowcase data-id="element-4" />
        <EmpathySection data-id="element-5" />
        <AntiagingTruth data-id="element-6" />
        <MethodPillars data-id="element-7" />
        <BeforeAfter data-id="element-8" />
        <ExpertSection data-id="element-9" />
        <EbookContents data-id="element-10" />

        <BonusStack data-id="element-11" />

        <Guarantee data-id="element-12" />
        <Testimonials data-id="element-13" />
        <FAQ data-id="element-14" />
        <Urgency data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>

      <Footer data-id="element-17" />

      {/* Meta Pixel — PageView + ViewContent on load */}
      <MetaPixel data-id="element-18" />

      {/* Social proof popup */}
      <RecentPurchasePopup data-id="element-19" />
    </div>;
}